import { InputHTMLAttributes, forwardRef } from 'react';

export interface FormInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  error?: boolean;
  fullWidth?: boolean;
}

/**
 * Styled input component with error state
 */
export const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  ({ error, fullWidth = true, className = '', ...props }, ref) => {
    const baseClasses = 'rounded-md border px-3 py-2 text-sm transition-colors';
    const widthClasses = fullWidth ? 'w-full' : '';
    const stateClasses = error
      ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
      : 'border-zinc-300 focus:border-blue-500 focus:ring-blue-500';
    const interactionClasses = 'focus:outline-none focus:ring-2 focus:ring-opacity-50';
    const disabledClasses = props.disabled ? 'bg-zinc-100 cursor-not-allowed' : 'bg-white';

    return (
      <input
        data-tsx-id="form-input"
        ref={ref}
        className={`${baseClasses} ${widthClasses} ${stateClasses} ${interactionClasses} ${disabledClasses} ${className}`}
        {...props}
      />
    );
  }
);

FormInput.displayName = 'FormInput';
